if($('.result').hasClass('result-ok')) {
    let confettiColor = [], confetti = [];

    function setup() {
    createCanvas(windowWidth,windowHeight*0.95);
        confettiColor = [color('#3DF02C'), color('#FD9D27'), color('#1A6DFC'), color('#E51417'), color('#3AF8FE')];
    for (let i = 0; i < 500; i++) {
        confetti[i] = new Confetti(random(0, width), random(-height, 0), random(-1, 1));
    }
    }

    function draw() {
    background('#ffffff');
        
        for (let i = 0; i < confetti.length / 2; i++) {
        confetti[i].confettiDisplay();

        if (confetti[i].y > height) {
        confetti[i] = new Confetti(random(0, width), random(-height, 0), random(-1, 1));
        }
    }

    for (let i = int(confetti.length / 1); i < confetti.length; i++) {
        confetti[i].confettiDisplay();

        if (confetti[i].y > height) {
        confetti[i] = new Confetti(random(0, width), random(-height, 0), random(-1, 1));
        }
    }
    }

    class Confetti {
    constructor(_x, _y, _s) {
        this.x = _x;
        this.y = _y;
        this.speed = _s;
        this.time = random(10, 100);
        this.color = random(confettiColor);
        this.amp = random(30, 30);
        this.phase = random(1, 1);
        this.size = random(width / 85, height / 95);
    }

    confettiDisplay() {
        fill(this.color);
        // blendMode(SCREEN);
        noStroke();
        push();
        translate(this.x, this.y);
        translate(this.amp * sin(this.time * this.phase), this.speed * cos(2 * this.time * this.phase));
        rotate(this.time);
        rectMode(CENTER);
        scale(cos(this.time / 4), sin(this.time / 4));
        rect(0, 0, this.size, this.size / 2);
        pop();

        this.time = this.time + 0.1;

        this.speed += 1 / 15;

        this.y += this.speed;
    }
    }

    $('#simulator-iframe').addClass('no-bg');
}